import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import carouselData from "./../../assets/data/carouselData";
import ElectedExecutives from "./ElectedExecutives";
import { WelcomeMessage } from "../Home/WelcomeMessage";

function Home() {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const styles = {
    container: {
      width: "100%",
      margin: "0 auto",
      background: "#f9f9f9",
    },
    carouselItem: {
      position: "relative",
      width: "100%",
      height: "600px",
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    textOverlay: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)", // Center the element
      color: "white",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      padding: "20px",
      borderRadius: "8px",
      textAlign: "center", // Change this to 'center' if you want the text to align centrally
      maxWidth: "90%", // Ensure responsiveness on mobile
      width: "100%",
      boxSizing: "border-box", // Include padding in width calculation
    },

    heading: {
      fontSize: "2.5rem",
      fontWeight: "bold",
      marginBottom: "10px",
      lineHeight: "1.2",
    },
  };

  return (
    <div style={styles.container}>
      {/* Carousel Section */}
      <div style={{ marginBottom: "40px" }}>
        <Carousel
          activeIndex={index}
          onSelect={handleSelect}
          controls={true}
          indicators={true}
          interval={3000}
          touch={true}
          keyboard={true}
          fade
        >
          {carouselData.map((item, idx) => (
            <Carousel.Item
              key={idx}
              style={{
                ...styles.carouselItem,
                backgroundImage: `url(${item.image})`,
              }}
            >
              <div style={styles.textOverlay}>
                <div style={styles.heading}>{item.text}</div>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <WelcomeMessage />
      {/* Executives Section */}
      <ElectedExecutives />
    </div>
  );
}

export default Home;
